import { Component, input, Input } from '@angular/core';

@Component({
    selector: 'avd-page-title',
    standalone: true,
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
    @Input() title = '';
    @Input() imgSrc = '';
}
